export const COMMANDE_RESET = "COMMANDE_RESET";
export const COMMANDE_SET_ERROR = "COMMANDE_SET_ERROR";
export const COMMANDE_SET_ITEMS = "COMMANDE_SET_ITEMS";
export const COMMANDE_TOGGLE_LOADING = "COMMANDE_TOGGLE_LOADING";
